// TopStats.tsx
import React from "react";

interface Stat {
  number: number;
  text: string;
  icon: React.ReactNode; 
  color?: string;        
}

interface TopStatsProps {
  stats: Stat[];
  module?: string;
}

export default function TopStats({ stats, module }: TopStatsProps) {

  return (
    <div className="row g-3 mb-10">
      {stats.map((s, i) => {
        const formattedNumber = s.number < 10 ? `0${s.number}` : s.number;

        return (
          <div className="col-12 col-sm-6 col-lg-3" key={i}>
            <div
              className="card h-100 border-0"
              style={{ backgroundColor: "#FFFFFF" }}
            >
              <div
                className="card-body d-flex flex-column justify-content-between"
                style={{ padding: "15px", minHeight: '115px' }}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <h5
                    className="fw-bold mb-0"
                    style={{ fontSize: "30px", fontWeight: 700 }}
                  >
                    {formattedNumber}
                  </h5>

                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "14px",
                      backgroundColor: s.color || "#E2E8F0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {s.icon}
                  </div>
                </div>
                <p
                  className="mb-0"
                  style={{ fontSize: "12px", fontWeight: 500, color: "#2A3E50" }}
                >
                  {s.text}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
